/*
  Bundle por cantidad (snippets/product-bundle.liquid): al elegir un pack, marca la opción
  y pone su cantidad en el campo oculto "quantity" que manda el botón Agregar al carrito.
*/
(function () {
  function sync(bundle) {
    var checked = bundle.querySelector('input[type="radio"]:checked');
    if (!checked) {
      return;
    }

    bundle.querySelectorAll('[data-om-bundle-pack]').forEach(function (pack) {
      pack.classList.toggle('is-selected', pack.contains(checked));
    });

    var qty = bundle.querySelector('[data-om-bundle-qty]');
    if (qty) {
      qty.value = checked.value;
    }
  }

  function init(root) {
    root.querySelectorAll('[data-om-bundle]').forEach(function (bundle) {
      if (bundle.dataset.omBundleReady) {
        return;
      }
      bundle.dataset.omBundleReady = 'true';
      bundle.addEventListener('change', function () {
        sync(bundle);
      });
      sync(bundle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Editor de temas: la sección se vuelve a renderizar al cambiar ajustes
  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target);
  });
})();
